define(function () {
    /**
     * Mockable proxy for window.location
     */

    return {
        getHash : function getHash() {
            return window.location.hash;
        }
    };
});



//////////////////
// WEBPACK FOOTER
// ./static/src/javascripts-legacy/lib/location.js
// module id = 271
// module chunks = 0 1 15